import unescapedText from 'I18n/utils/unescapedText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import { jsx as _jsx } from "react/jsx-runtime";
const getModalText = () => {
  return {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "invoices.components.modals.deletion.title"
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "invoices.components.modals.deletion.description"
    }),
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "invoices.components.modals.deletion.confirm"
    }),
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "invoices.components.modals.deletion.reject"
    })
  };
};
const InvoiceDeleteModal = props => {
  const {
    loading,
    onClose,
    onConfirm
  } = props;
  const {
    title,
    description,
    confirmLabel,
    rejectLabel
  } = getModalText();
  return /*#__PURE__*/_jsx(ConfirmModal, {
    "data-test-id": "invoice-delete-modal",
    confirmUse: "danger",
    size: "auto",
    use: "danger",
    message: title,
    match: unescapedText('invoices.components.modals.deletion.matcherPlaceholder'),
    matcherLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "invoices.components.modals.deletion.matcherLabel"
    }),
    description: description,
    confirmLabel: confirmLabel,
    rejectLabel: rejectLabel,
    confirmButtonProps: {
      loading
    },
    ConfirmButton: LoadingButton,
    onConfirm: onConfirm,
    onReject: onClose
  });
};
export default InvoiceDeleteModal;